/**
 * In-memory API response logger for dex screen. Capture is wired from API client response interceptor.
 */
const MAX_ENTRIES = 200;
const store: Record<string, { method: string; endpoint: string; status: number; timestamp: string; response: unknown }> = {};
let sequence = 0;

function nextKey(): string {
  sequence += 1;
  return `res_${Date.now()}_${sequence}`;
}

export const ApiResponseLogger = {
  capture(config: { url?: string; method?: string }, response?: { status?: number; data?: unknown }): void {
    const url = config?.url ?? '';
    const method = (config?.method ?? 'get').toUpperCase();
    const status = response?.status ?? 0;
    const data = response?.data;
    const key = nextKey();
    const endpoint = url.replace(/^https?:\/\/[^/]+/, '') || url;
    store[key] = {
      method,
      endpoint,
      status,
      timestamp: new Date().toISOString(),
      response: data,
    };
    const keys = Object.keys(store);
    if (keys.length > MAX_ENTRIES) {
      keys.sort();
      for (let i = 0; i < keys.length - MAX_ENTRIES; i++) {
        delete store[keys[i]];
      }
    }
  },

  getAllResponses(): Promise<Record<string, any>> {
    return Promise.resolve({ ...store });
  },

  clearAll(): Promise<void> {
    Object.keys(store).forEach(k => delete store[k]);
    return Promise.resolve();
  },

  exportToConsole(): Promise<void> {
    return Promise.resolve();
  },
};
